import { createTypes, completeTypes, withPostSuccess, withPostFailure } from 'redux-recompose';

import { handleAPIErrors } from '~model/errors';
import StoresService from '~services/Store/service';

export const actions = createTypes(
  completeTypes(['GET_STORES', 'GET_STORE_BY_ID', 'UPDATE_STORE', 'GET_ALL_STORES'], []),
  '@@STORES'
);

const targets = {
  STORES: 'stores',
  STORE_BY_ID: 'storeById',
  UPDATE_STORE: 'updateStore',
  ALL_STORES: 'allStores'
};

const actionCreators = {
  getStores: () => ({
    type: actions.GET_STORES,
    service: StoresService.getStores,
    target: targets.STORES,
    injections: [
      withPostFailure((_, response) => {
        handleAPIErrors(response);
      })
    ]
  }),
  getAllStores: () => ({
    type: actions.GET_ALL_STORES,
    service: StoresService.getAllStores,
    target: targets.ALL_STORES,
    injections: [
      withPostFailure((_, response) => {
        handleAPIErrors(response);
      })
    ]
  }),
  getStoreById: (id) => ({
    type: actions.GET_STORE_BY_ID,
    target: targets.STORE_BY_ID,
    payload: id,
    service: StoresService.getStoreById,
    successSelector: ({ data }) => {
      return {
        ...data,
        enabledManualDelivery: !data.enabledManualDelivery
      };
    }
  }),
  updateStore: (store, onPostSuccess, onPostFailure) => ({
    type: actions.UPDATE_STORE,
    target: targets.UPDATE_STORE,
    payload: store,
    service: StoresService.updateStore,
    successSelector: ({ data }) => {
      return {
        ...data,
        enabledManualDelivery: !data.enabledManualDelivery
      };
    },
    injections: [
      withPostFailure((_, response) => {
        handleAPIErrors(response);
        if (onPostFailure) onPostFailure();
      }),
      withPostSuccess(() => {
        if (onPostSuccess) onPostSuccess();
      })
    ]
  })
};

export default actionCreators;
